import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    href: '#problem',
    label: 'Problem'
  }, {
    href: '#solution',
    label: 'Solution'
  }, {
    href: '#what-you-get',
    label: 'What You Get'
  }, {
    href: '#reviews',
    label: 'Reviews'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-dark-bg/90 backdrop-blur-md border-b border-dark-border py-3' : 'bg-transparent py-5'}`} data-id="element-188">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 flex items-center justify-between" data-id="element-189">
        <div className="flex items-center gap-3" data-id="element-190">
          <span className="font-playfair font-semibold text-text-primary" data-id="element-191">
            Erectile Diffusion Guide
          </span>
        </div>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-8 text-sm font-medium text-text-secondary" data-id="element-192">
          {navLinks.map(link => <a key={link.href} href={link.href} className="hover:text-gold transition-colors" data-id="element-193">
              {link.label}
            </a>)}
        </div>

        <div className="flex items-center gap-3" data-id="element-194">
          <a href="#pricing" className="bg-gold hover:bg-gold-hover text-dark-bg font-bold py-1.5 px-3 md:py-2 md:px-6 rounded transition-colors text-xs md:text-sm" data-id="element-195">
            PDF — $6.39
          </a>

          {/* Mobile hamburger */}
          <button onClick={() => setMenuOpen(!menuOpen)} className="md:hidden text-text-primary p-1" aria-label="Toggle menu" data-id="element-196">
            {menuOpen ? <XIcon className="w-6 h-6" data-id="element-197" /> : <MenuIcon className="w-6 h-6" data-id="element-198" />}
          </button>
        </div>
      </div>

      {/* Mobile dropdown */}
      <div className={`md:hidden overflow-hidden transition-all duration-300 ease-in-out ${menuOpen ? 'max-h-64 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-199">
        <div className="bg-dark-bg/95 backdrop-blur-md border-t border-dark-border px-6 py-4 flex flex-col gap-4" data-id="element-200">
          {navLinks.map(link => <a key={link.href} href={link.href} onClick={() => setMenuOpen(false)} className="text-sm font-medium text-text-secondary hover:text-gold transition-colors py-1" data-id="element-201">
              {link.label}
            </a>)}
        </div>
      </div>
    </nav>;
}